import { TextInput } from '@mantine/core';
import { motion } from 'framer-motion';
import React from 'react';

import { ImageSelectorField } from '@portals/autoformik';

import DomainEdit from './DomainEdit';
import { useBrandingContext } from '../../../../../branding.context';
import { ContentWrapper, TabContainer } from '../common';

export function Domain() {
  const { portalConfig, updatePortalConfig } = useBrandingContext();

  return (
    <TabContainer>
      <ContentWrapper>
        <DomainEdit />

        <motion.div layout="position">
          <TextInput
            label="Window title"
            placeholder="Xyte - Simply Connected"
            mb="md"
            value={portalConfig.window_title || ''}
            onChange={(event) =>
              updatePortalConfig((currData) => ({
                ...currData,
                window_title: event.target.value,
              }))
            }
          />
        </motion.div>

        <motion.div layout="position">
          <ImageSelectorField
            horizontal={false}
            setFieldValue={(_, value: string) =>
              updatePortalConfig((curr) => ({
                ...curr,
                favicon: value,
              }))
            }
            field={{
              title: 'Favicon',
              name: 'favicon',
              height: 200,
              cropConfig: {
                aspectRatio: 1,
                width: 96,
                height: 96,
              },
              previewConfig: {
                width: 96,
                height: 96,
              },
            }}
            value={portalConfig.favicon || ''}
          />
        </motion.div>
      </ContentWrapper>
    </TabContainer>
  );
}
